export default {
  title: "История операций",
  number: "Номер",
  entityName: "Название организации",
  type: "Тип операции",
  typeBuyTariff: "Покупка тарифа",
  typeAddBalance: "Пополнение баланса",
  typePaymentAct: "Оплата счета по акту",
  typePaymentAcceptance: "Оплата тестового платежа",
  amount: "Сумма",
  currency: "Валюта",
  date: "Дата и время",
  noHistory: "Ваша история пуста",
  operationsTab: "Все операции",
  processingTab: "RC Processing",
  reward: "Вознаграждение",
  paidFromPurchase:
    "{cash} {currency} оплачено <span>(с покупки на {amount} {currency})</span>",
  downloadModal: {
    title: "Скачать файл",
    fileType: "Тип файла",
    sendOnEmail: "Отправить копию на почту",
    CPUnloadingOperationHistory: "(КП) Выгрузка Истории операций",
  },
  couldntCreateUnloading: "Не удалось создать выгрузку",
  giftCard: "Подарочная карта",
  orderNumber: "Номер заказа",
  paymentMethod: "Способ оплаты",
  inCheckSpecifiedPercentAndSumAward:
    "В чеке указан общий процент и сумма вознаграждения.",
  itsMayNotMatchWithFactSum:
    "Он может не совпадать с суммой фактически списанных баллов, так как зависит от того, какой клиент совершил покупку (внутренний или внешний), а также от его тарифа.",
};
